import React, { useState } from "react";
import styled from "styled-components";
import moment from "moment";

const Dable = styled.table`
	font-size: 12px;
	text-align: center;
	a {
		cursor: pointer;
	}
`;
const toINR = (num) => {
	return "₹ " + parseInt(num).toLocaleString("en-IN");
};
export default class Table extends React.Component {
	state = {
		page: 0,
		perpage: 10,
	};
	render() {
		const { page, perpage } = this.state;
		const rows = this.props.data;
		if (!rows) return <>Loading...</>;
		if (rows.length === 0) {
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexDirection: "column",
						marginTop: "50px",
					}}
				>
					<img
						src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/No+data-amico+1.svg"
						height={200}
					/>
					<p className="empty-title h5">No records found</p>
				</div>
			);
		}
		return (
			<>
				<Dable className="table">
					<thead>
						<tr>
							<th>Date</th>
							<th>Type</th>
							<th>Amount</th>
							<th>Balance</th>
							<th>Channel</th>
							<th>Transaction Note</th>
						</tr>
					</thead>
					<tbody>
						{rows.slice(page * perpage, (page + 1) * perpage).map((row) => (
							<tr>
								<td>{moment(row.date).format("MMM DD, YYYY")}</td>
								<td>
									{row.transaction_type === "credit" ? (
										<span style={{ color: "green" }}>Credit</span>
									) : (
										<span style={{ color: "red" }}>Debit</span>
									)}
								</td>
								<td>{toINR(row.amount)}</td>
								<td>{toINR(row.balance)}</td>
								<td>{row.transaction_channel}</td>
								<td>{row.transaction_note}</td>
							</tr>
						))}
					</tbody>
				</Dable>
				<ul className="pagination" style={{ justifyContent: "center" }}>
					<li
						style={{ cursor: "pointer" }}
						className={`page-item ${page === 0 && "disabled"}`}
					>
						<a onClick={() => this.setState({ page: page - 1 })} tabindex="-1">
							Previous
						</a>
					</li>
					<li className="page-item">
						<a tabIndex="-1">{page + 1}</a>
					</li>
					<li
						style={{ cursor: "pointer" }}
						className={`page-item ${page === parseInt(rows.length / perpage) && "disabled"}`}
					>
						<a onClick={() => this.setState({ page: page + 1 })}>Next</a>
					</li>
				</ul>
			</>
		);
	}
}
